import { render, staticRenderFns } from "./quickRegister.vue?vue&type=template&id=457ba6eb"
import script from "./quickRegister.vue?vue&type=script&lang=js"
export * from "./quickRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports